/** API may return is_active (0/1) and/or legacy status string */
export function isCategoryActive(category) {
  if (category == null) return true;
  const v = category.is_active;
  if (v === 0 || v === false || v === '0') return false;
  if (v === 1 || v === true || v === '1') return true;
  const s = category.status;
  if (s === 'Inactive') return false;
  if (s === 'Active') return true;
  return true;
}

export function categoryStatusLabel(category) {
  return isCategoryActive(category) ? 'Active' : 'Inactive';
}
